import { render, staticRenderFns } from "./PazienteSchedaComponent.vue?vue&type=template&id=30a05bd2&scoped=true"
import script from "./PazienteSchedaComponent.vue?vue&type=script&lang=js"
export * from "./PazienteSchedaComponent.vue?vue&type=script&lang=js"
import style0 from "./PazienteSchedaComponent.vue?vue&type=style&index=0&id=30a05bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a05bd2",
  null
  
)

export default component.exports